import firebase from 'firebase'
import firestore from 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDnN73Cl--TRDgEn89HCvvvFX86SGfUtss",
  authDomain: "vue-app-799f9.firebaseapp.com",
  projectId: "vue-app-799f9",
  storageBucket: "vue-app-799f9.appspot.com",
  messagingSenderId: "920198057452",
  appId: "1:920198057452:web:0fa2ca97c6f1cb22a5c4c9",
  measurementId: "G-BTFFL8R67Z"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebaseApp.firestore()